/* eslint-disable object-shorthand */

export var PACKAGE_BUILD_DATE = '2026-07-08T18:13:01.142Z';
export var PACKAGE_NAME = 'invision-customercare';
export var PACKAGE_VERSION = '26.2.10500-2397788';
export default {
  PACKAGE_BUILD_DATE: PACKAGE_BUILD_DATE,
  PACKAGE_NAME: PACKAGE_NAME,
  PACKAGE_VERSION: PACKAGE_VERSION
};